import { useTranslation } from "react-i18next";
import Collapse from "../../common/Collapse";
import {
  renderTemplateOpeningSlidePreview,
  renderTemplateSlideItemPreview,
} from "../templates";

export default function SlidesPreviewSection({ videoData }) {
  const { t } = useTranslation();

  if (
    !videoData?.creationConfig?.slideItems ||
    videoData?.creationConfig?.slideItems?.length === 0
  ) {
    return (
      <Collapse
        title={
          <div className="font-semibold text-gray-800 text-2xl">
            {t("slides preview")}
          </div>
        }
        className="mb-6"
        defaultOpen
      >
        <div className="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
          <div className="text-gray-400 text-6xl mb-4">📄</div>
          <p className="text-gray-500 font-semibold mb-2">
            {t("no slides available")}
          </p>
          <p className="text-sm text-gray-400">
            {t("there are no slides to display for this video")}
          </p>
        </div>
      </Collapse>
    );
  }
  const openingSlide = renderTemplateOpeningSlidePreview({
    template: videoData?.template,
    logo: videoData?.creationConfig?.openingSlide?.logo,
    backgroundColor: videoData?.creationConfig?.openingSlide?.backgroundColor,
  });

  return (
    <Collapse
      title={
        <div className="font-semibold text-gray-800 text-2xl">
          {t("slides preview")} (
          {videoData?.creationConfig?.slideItems?.length +
            (openingSlide ? 1 : 0)}
          )
        </div>
      }
      className="mb-6"
      defaultOpen
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {!!openingSlide && (
          <div className="bg-white border rounded-lg p-4 hover:shadow-lg transition-shadow">
            <div className="flex flex-col gap-3">
              <div className="w-full">{openingSlide}</div>
            </div>
          </div>
        )}

        {videoData?.creationConfig?.slideItems?.map((news, index) => (
          <div
            key={news.id || index}
            className="bg-white border rounded-lg p-4 hover:shadow-lg transition-shadow"
          >
            <div className="flex flex-col gap-3">
              <div className="w-full">
                {renderTemplateSlideItemPreview({
                  template: videoData?.template,
                  news: {
                    ...news,
                    image: news.imageUrl,
                  },
                  styleSettings: { slideItem: news },
                })}
              </div>

              {news.voiceText && (
                <div className="text-xs text-gray-600 italic border-l-4 border-empower-500 pl-2 bg-gray-50 rounded-r-md py-2">
                  <div className="font-semibold text-gray-700 mb-1">
                    {t("voice text")}:
                  </div>
                  <p className="line-clamp-3">{news.voiceText}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Collapse>
  );
}
